module.exports = __webpack_public_path__ + "static/media/ic_add_image.cbb9e84f.svg";